import { Share } from '@capacitor/share';
import { env } from './env';

/** Compartir un enlace: hoja nativa (Android/iPhone) o, si no existe, copiar al portapapeles. */
export async function shareLink(url: string, title: string, text: string): Promise<'shared' | 'copied' | 'cancelled'> {
  try {
    if (env.isNative) {
      await Share.share({ title, text, url, dialogTitle: title });
      return 'shared';
    }
    if (navigator.share) {
      await navigator.share({ title, text, url });
      return 'shared';
    }
  } catch (e) {
    if ((e as Error).name === 'AbortError' || /cancel/i.test(String((e as Error).message))) return 'cancelled';
  }
  await navigator.clipboard.writeText(`${text} ${url}`);
  return 'copied';
}
